module.exports = __webpack_public_path__ + "static/img/图层49.069f7d03.png";